module.exports = __webpack_public_path__ + "img/María Paula Fernandez.5f3faf5b.jpg";